// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qy_Bfs8_klBBs6 {
  height: 20px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
  width: 70%;
  margin: 0 auto;
}
.qy_Bfs8_klBBs6::before {
  content: '';
  display: block;
  width: 100%;
}
.miXwxPzTyVWjhb::before {
  border-top: 2px solid var(--ds-border, #091e4224);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"separatorCard": `qy_Bfs8_klBBs6`,
	"singleHorizontalLine": `miXwxPzTyVWjhb`
};
export default ___CSS_LOADER_EXPORT___;
